module.exports = __webpack_public_path__ + "static/media/info.738a9454.svg";